/*
 * <product-tabs> — the product info tabs (snippets/product-tabs.liquid).
 * Click and arrow/Home/End keyboard support, roving tabindex, panel visibility.
 */
if (!customElements.get('product-tabs')) {
  customElements.define(
    'product-tabs',
    class ProductTabs extends HTMLElement {
      constructor() {
        super();
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        this.list = this.querySelector('.product-tabs__list');

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(index));
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
        });
      }

      select(index) {
        // Keep the tab strip visually anchored across the switch. On desktop the
        // CSS grid stack already holds the panel height steady; this covers the
        // mobile case, where a collapsing panel would otherwise shift the page.
        const anchorTop = this.list ? this.list.getBoundingClientRect().top : null;

        this.tabs.forEach((tab, i) => {
          const active = i === index;
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.tabIndex = active ? 0 : -1;
          if (this.panels[i]) this.panels[i].hidden = !active;
        });

        if (anchorTop !== null) {
          const delta = this.list.getBoundingClientRect().top - anchorTop;
          if (Math.abs(delta) > 1) window.scrollBy(0, delta);
        }
      }

      onKeydown(event, index) {
        const last = this.tabs.length - 1;
        let next;

        switch (event.key) {
          case 'ArrowRight':
          case 'ArrowDown':
            next = index === last ? 0 : index + 1;
            break;
          case 'ArrowLeft':
          case 'ArrowUp':
            next = index === 0 ? last : index - 1;
            break;
          case 'Home':
            next = 0;
            break;
          case 'End':
            next = last;
            break;
          default:
            return;
        }

        event.preventDefault();
        this.select(next);
        this.tabs[next].focus();
      }
    }
  );
}
